module.exports = "/assets/f753c42225a53d8ed8e2d6b29ecc68a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/4L.png
// module id = 1038
// module chunks = 0